module.exports = {"130427100":"磁州镇","130427103":"讲武城镇","130427104":"岳城镇","130427105":"观台镇","130427107":"白土镇","130427108":"黄沙镇","130427200":"路村营乡","130427204":"时村营乡","130427207":"陶泉乡","130427208":"都党乡","130427209":"北贾壁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130427.json
// module id = 205
// module chunks = 0